export default __webpack_public_path__ + "static/media/atlas_dark.afdd9912.svg";